import { render, staticRenderFns } from "./CustomRecipientModal.vue?vue&type=template&id=073020b2"
import script from "./CustomRecipientModal.vue?vue&type=script&lang=js"
export * from "./CustomRecipientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports